import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@mui/styles';
import MenuItem from '../../MenuItem/MenuItem';
import Select from '../../Select/Select';

const useStyles = makeStyles({
  noPaddingLeft: {
    '& .MuiSelect-select': {
      paddingLeft: 0,
    },
  },
});

export const OperatorSelector = ({ value, style, onChange, options }) => {
  const classes = useStyles();

  return (
    <Select
      value={value}
      style={style}
      onChange={(e) => onChange(e.target.value)}
      classes={{
        select: classes.noPaddingLeft,
      }}
    >
      {options.map(({ name, label, color }) => (
        <MenuItem key={name} value={name} title={label}>
          <span>
            <div className="query-builder-operator-indicator" style={{ backgroundColor: color }} />
            {label}
          </span>
        </MenuItem>
      ))}
    </Select>
  );
};

OperatorSelector.propTypes = {
  value: PropTypes.string,
  style: PropTypes.object,
  options: PropTypes.array,
  onChange: PropTypes.func,
};
